<div class="d-flex flex-column">
    <h3>Selecione uma Categoria</h3>
    <span style="font-size: 18px;">
        <p>
            O Produto selecionado não possui categoria atribuída, <br/>
            por favor, selecione uma das categorias abaixo para atribuir ao produto
        </p>
        <p style="font-style: italic;">
            Isso será necessário apenas uma vez
        </p>
    </span>
</div>
<div>
    <form class="d-flex flex-row" [formGroup]="formCategory">
        <div class="col-lg-8" style="margin-right: 0.025rem;">
            <label for="category">
                Categoria
            </label>
            <div>
                <ng-select 
                    formControlName="category_id" 
                    id="category" 
                    name="category"
                    appendTo="body"
                    [placeholder]="loadingCategories ? 'Carregando Categorias, aguarde...' : 'Selecione uma Categoria…' "
                    >
                    <ng-option *ngFor="let category of categories" [value]="category.id">
                        {{category.description | titlecase}}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="d-flex flex-row align-items-end">
            <button 
                type="submit" 
                class="btn btn-success"
                (click)="onSubmit()"
                >
                <i class="bi bi-plus"></i>
                Atribuir Categoria
            </button>
        </div>
    </form>
</div>